import moment from 'moment-timezone'
import * as Immutable from 'immutable'
import campaignService from '../../../services/campaigns-service'
import captivePortalService from '../../../services/captive-portal-servie'

let SET_CAPTIVE_PORTAL_FILTER = 'SET_CAPTIVE_PORTAL_FILTER'
let LOAD_STORE_OPTIONS_CAPTIVE = 'LOAD_STORE_OPTIONS_CAPTIVE'
let LOAD_CAPTIVE_PORTAL_USERS = 'LOAD_CAPTIVE_PORTAL_USERS'
let LOAD_CAPTIVE_PORTAL_CSV = 'LOAD_CAPTIVE_PORTAL_CSV'

export function setCaptivePortalFilter (filter) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CAPTIVE_PORTAL_FILTER,
      filter: filter
    })
  }
}

export function loadStoreOptions () {
  return (dispatch, getState) => {
    return campaignService.getStores().then((stores) => {
      let options = stores.map(store => {
        return {label: store.store, value: store.store}
      })
      dispatch({
        type: LOAD_STORE_OPTIONS_CAPTIVE,
        storeOptions: options
      })
    })
  }
}

export function loadCaptivePortalUsers (filter) {
  return (dispatch, getState) => {
    return captivePortalService.getCaptivePortalUserDetails(filter)
      .then(function (captivePortalUsers) {
        dispatch({
          type: LOAD_CAPTIVE_PORTAL_USERS,
          captivePortalUsers: Immutable.fromJS(captivePortalUsers)
        })
      })
  }
}

export function loadCaptivePortalCsv (query) {
  return (dispatch, getState) => {
    return captivePortalService.exportCaptivePortalUsers(query)
      .then(function (captivePortalCsv) {
        dispatch({
          type: LOAD_CAPTIVE_PORTAL_CSV,
          captivePortalCsv: captivePortalCsv
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultFilter = Immutable.fromJS({
  startDate: moment().subtract(6, 'days').toDate(),
  endDate: moment().toDate(),
  storeNames: []
})

export function captivePortalFilterReducer (state = defaultFilter, action) {
  switch (action.type) {
    case SET_CAPTIVE_PORTAL_FILTER: {
      return action.filter
    }
    default:
      return state
  }
}

let defaultWalkInInterests = Immutable.fromJS([])

export function captivePortalUsersReducer (state = defaultWalkInInterests, action) {
  switch (action.type) {
    case LOAD_CAPTIVE_PORTAL_USERS: {
      return action.captivePortalUsers
    }
    default:
      return state
  }
}

export function loadStoreOptionsReducer (state = [], action) {
  switch (action.type) {
    case LOAD_STORE_OPTIONS_CAPTIVE: {
      return action.storeOptions
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/CaptivePortal/models/captivePortal.js